// extracted by mini-css-extract-plugin
export default {"mailIconWrapper":"mailIconWrapper__MmMwO","inboxNotification":"inboxNotification__OWYwY"};